<template>
  <div
    v-if="isComplete"
    v-tooltip="{
      content: `${$t('pages.submissions.components.upload.results.validator.in_progress')}`,
      placement: 'bottom'
    }"
    :class="$style.binaryProcessing"
  >
    <animation-processing fill="grey" />
  </div>
  <div v-else>
    <error-icon
      v-if="Object.hasOwn(errors, `style name${index}`) || hasResultError(result)"
      v-tooltip="{
        content: `${$t('pages.submissions.components.upload.results.validator.error_level.error')}`,
        placement: 'bottom'
      }"
      :class="$style.resultStatusIcon"
    />
    <warning-icon
      v-else-if="hasResultWarning(result) && !hasResultError(result)"
      v-tooltip="{
        content: `${$t('pages.submissions.components.upload.results.validator.error_level.warn')}`,
        placement: 'bottom'
      }"
      :class="$style.resultStatusIcon"
    />
    <ok-icon
      v-else
      v-tooltip="{
        content: `${$t('pages.submissions.components.upload.results.validator.error_level.ok')}`,
        placement: 'bottom'
      }"
      :class="$style.resultStatusIcon"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import AnimationProcessing from 'components/animations/processing'
import Methods from './script/results.methods.js'
import ErrorIcon from 'components/icons/error/'
import OkIcon from 'components/icons/ok/'
import WarningIcon from 'components/icons/warning/'
import { useForm } from 'vee-validate'
export default {
  name: 'BinaryValidationIcons',

  components: {
    AnimationProcessing,
    ErrorIcon,
    OkIcon,
    WarningIcon
  },

  props: {
    isComplete: {
      type: Boolean,
      default: true
    },
    result: {
      type: Object,
      default: () => { }
    },
    index: {
      type: Number,
      default: 0
    }
  },

  setup() {
    const { errors } = useForm()
    return {
      errors,
    }
  },

  methods: {
    ...Methods,
  }
}
</script>

<style lang="scss" src="./stylesheets/index.scss" module></style>
